import graphql from "babel-plugin-relay/macro";

export const NODE_QUERY = graphql`
	query moduleRatingsDetails_Query($nodeRef: ID!) {
		node(id: $nodeRef) {
			... on LearnOpportunityV2 {
				structureDefinition {
					title
				}
			}
		}
	}
`;
